/* eslint-disable */
// /src/pages/SalesRankingPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import styled, { keyframes } from "styled-components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion, useReducedMotion, MotionConfig } from "framer-motion";
import BrandHeader from "../components/BrandHeader";
import heroImg from "../assets/images/dhmobility_heyway_banner.png";
import corp1 from "../assets/sales/corp1.png";
import person2 from "../assets/sales/person2.png";
import person3 from "../assets/sales/person3.png";
import person4 from "../assets/sales/person4.png";

import { fetchTopSettlementsByFare } from "../services/settlementsRankingService";
import { useDriverStatus } from "hooks/useDriverStatus";
import { useAppConfig } from "../context/AppConfigContext";
import { useDriverStatusContext } from "context/DriverStatusContext";
import { getPublishedOnce } from "services/homeConfigService";
import PageTopBar from "../components/PageTopBar";

/* ================= 공통 유틸 ================= */
// settlementMonthKey → "10월" 같은 월 문자열로 변환
function formatSettlementMonthLabel(key) {
  if (!key) return "";

  const raw = String(key).trim();
  let month;

  // 예: "2025-10"
  if (/^\d{4}-\d{2}$/.test(raw)) {
    const parts = raw.split("-");
    month = parts[1];
  }
  // 예: "202510"
  else if (/^\d{6}$/.test(raw)) {
    month = raw.slice(4);
  } else {
    return "";
  }

  const mNum = Number(month);
  if (!mNum || mNum < 1 || mNum > 12) return "";

  return `${mNum}월`;
}

/* ================= Layout ================= */
const Wrap = styled.div`
  min-height: 100vh;
  background: #eaf3ff;
  display: flex;
  flex-direction: column;
`;
const Sheet = styled.div`
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;
const Hero = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
  overflow: hidden;

`;
const HeroText = styled.div`
  position: absolute;
  left: 16px;
  right: 10px;
  top:20px;
  bottom: 12px;
  color: #131313;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 12px;
  h1 {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    letter-spacing: -0.2px;
  }
`;
const LinkBtn = styled.button`
  border: 2px solid
    ${(p) => (p.$locked ? "#9ca3af" : "#d1d5db")}; /* 항상 연한 테두리 */

  color: #111827;
  height: 36px;
  padding: 0 14px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 800;
  cursor: pointer;
  backdrop-filter: blur(2px);
  transition: background 0.15s ease-out, border-color 0.15s ease-out;


`;
const Body = styled.div`
  flex: 1;
  display: grid;
  grid-template-rows: auto auto auto 1fr auto;
  row-gap: 14px;
  padding: 16px;
`;
const SectionTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
`;

const sweepBg = keyframes`
  0%   { transform: translateX(-160%) skewX(-16deg); opacity: 0; }
  8%   { opacity: .20; }
  40%  { opacity: .36; }
  100% { transform: translateX(160%)  skewX(-16deg); opacity: 0; }
`;
const boxSweep = keyframes`
  0%   { transform: translateX(-130%) rotate(0.8deg); opacity: 0; }
  10%  { opacity: .22; }
  50%  { opacity: .30; }
  100% { transform: translateX(130%)  rotate(0.8deg); opacity: 0; }
`;

// 기존 Card 정의만 교체
const Card = styled.div`
  position: relative;
  border-radius: 20px;
  padding: 16px;
  height: 380px;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    left: -35%;
    top: 42%;
    width: 46%;
    height: 24%;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1),
      inset 0 0 12px rgba(255, 255, 255, 0.45);
    filter: blur(2px);
    animation: ${boxSweep} 3.4s ease-in-out infinite;
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    top: -18%;
    bottom: -18%;
    left: -55%;
    width: 46%;
    background: linear-gradient(
      105deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 220, 140, 0.3) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    filter: blur(12px);
    transform: translateX(-160%) skewX(-16deg);
    animation: ${sweepBg} 3.6s ease-in-out infinite;
    animation-delay: 0.05s;
    pointer-events: none;
  }
`;

const CTA = styled.button`

  width: 100%;
  height: 60px;
  background: #fff;
  color: #1a2b4c;
  border: 2px solid #1a2b4c;
  border-radius: 18px;
  font-size: 18px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  &:active {
    transform: translateY(1px);
  }
`;
const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

const Arrow = () => (
  <span
    style={{
      width: 28,
      height: 28,
      borderRadius: 999,
      border: "2px solid #1a2b4c",
      display: "grid",
      placeItems: "center",
    }}
  >
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#1a2b4c"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  </span>
);

/* ================= 3D Tilt Bar ================= */
const PALETTE = {
  gold: {
    front: "linear-gradient(180deg,#FFE08A 0%,#FFD065 40%,#FFB84A 100%)",
    side: "linear-gradient(180deg,#E6B85A 0%,#D99C3F 55%,#C5832F 100%)",
  },
  silver: {
    front: "linear-gradient(180deg,#EAF0FF 0%,#CBD8FF 40%,#AFC4FF 100%)",
    side: "linear-gradient(180deg,#B9C7EC 0%,#9DAFDE 55%,#8BA0D4 100%)",
  },
  bronze: {
    front: "linear-gradient(180deg,#FFDCC4 0%,#FFC1A6 40%,#FFA183 100%)",
    side: "linear-gradient(180deg,#E2A587 0%,#CF8A6C 55%,#B9735A 100%)",
  },
};

const TiltWrap = styled(motion.div)`
  position: relative;
  width: 100%;
  height: ${(p) => p.$h || 240}px;
  transform-origin: bottom center;
  transform-style: preserve-3d;
  transform: perspective(900px) rotateY(${(p) => p.$tilt || 15}deg);
`;

const FrontFace = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 16px 16px 6px 6px;
  clip-path: polygon(8% 0%, 92% 0%, 100% 12%, 100% 100%, 0% 100%, 0% 12%);
  background: ${(p) => p.$bg};
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.28),
    inset 0 0 14px rgba(255, 255, 255, 0.35);
`;

const RightFace = styled.div`
  position: absolute;
  top: 6px;
  bottom: 0;
  width: ${(p) => p.$sideW || "10%"};
  right: ${(p) => `calc(-0.45 * ${p.$sideW || "10%"})`};
  background: ${(p) => p.$bg};
  border-bottom-right-radius: 6px;
  transform: skewY(-6deg);
  filter: drop-shadow(0 10px 16px rgba(0, 0, 0, 0.25));
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 10px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.6),
      rgba(255, 255, 255, 0)
    );
    opacity: 0.7;
  }
`;

// === 유틸: 이름 정리(성 + "00" 마스킹) ===
const prettyName = (s) => {
  if (!s) return "";
  const cleaned = String(s).replace(/\d+/g, "").trim();
  if (!cleaned) return "";
  const noSpace = cleaned.replace(/\s+/g, "");
  const initial = noSpace[0];
  return `${initial}00`;
};

// === 막대 위 오버레이 ===
const AvatarGroup = styled.div`
  position: relative;
  display: grid;
  justify-items: center;
  pointer-events: none;
  gap: 6px;
`;

const NameTop = styled.div`
  font-weight: 800;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.62);
  letter-spacing: -0.2px;
`;

// 파일 상단 styled-components 근처에 추가
const sweep = keyframes`
  0%   { transform: translateX(-120%) rotate(16deg); opacity: 0; }
  15%  { opacity: .85; }
  50%  { opacity: .95; }
  100% { transform: translateX(120%)  rotate(16deg); opacity: 0; }
`;

/* ===== 별 반짝임 Effect (1등 전용) ===== */
const twinkle = keyframes`
  0%   { transform: scale(0.6) rotate(0deg);   opacity: 0; }
  45%  { opacity: 1; }
  100% { transform: scale(1.1) rotate(180deg); opacity: 0; }
`;

/** 스파클 컬러 테마 */
const SPARKLE_THEME = {
  gold: { core: "#FFE788", glow: "255,231,136" },
  goldDeep: { core: "#FFC54D", glow: "255,200,90" },
  mint: { core: "#C5FFE9", glow: "197,255,233" },
  blue: { core: "#CFE5FF", glow: "167,207,255" },
  pink: { core: "#FFD1E6", glow: "255,161,210" },
  violet: { core: "#E2D2FF", glow: "200,170,255" },
};

const SparkleWrap = styled.div`
  position: absolute;
  left: 50%;
  top: -40px;
  width: 220px;
  height: 180px;
  transform: translateX(-50%);
  pointer-events: none;
  overflow: visible;
  z-index: 2;
`;

const Sparkle = styled.span`
  position: absolute;
  display: block;
  width: ${(p) => p.$s || 14}px;
  height: ${(p) => p.$s || 14}px;
  transform: translateZ(0);
  border-radius: 3px;
  --core: ${(p) => SPARKLE_THEME[p.$theme || "gold"]?.core};
  --glow: ${(p) => SPARKLE_THEME[p.$theme || "gold"]?.glow};
  background: radial-gradient(circle, #fff 0%, var(--core) 55%, rgba(0, 0, 0, 0)
        72%);
  box-shadow:
    0 0 10px rgba(var(--glow), 0.95),
    0 0 22px rgba(var(--glow), 0.55),
    0 0 40px rgba(var(--glow), 0.35);
  filter: saturate(1.1);
  animation: ${twinkle} ${(p) => p.$dur || 2.1}s ease-in-out infinite;
  animation-delay: ${(p) => p.$delay || 0}s;
  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 170%;
    height: 2px;
    border-radius: 2px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.95),
      rgba(255, 255, 255, 0)
    );
    box-shadow: 0 0 10px rgba(var(--glow), 0.65);
  }
  &::after {
    transform: translate(-50%, -50%) rotate(90deg);
  }
`;

const CrownShine = styled.div`
  position: absolute;
  top: -106px;
  left: 50%;
  width: 90px;
  height: 50px;
  transform: translateX(-50%);
  pointer-events: none;
  overflow: visible;
  &::after {
    content: "";
    position: absolute;
    top: -6px;
    left: -140%;
    width: 60%;
    height: 140%;
    background: linear-gradient(
      105deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.92) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    filter: blur(2px);
    animation: ${sweep} 2.4s ease-in-out infinite;
  }
`;

/* 상단 캡 숨김 */
const TopCap = styled.div`
  display: none;
`;

/* 여기부터 아바타 배경 제거 + 사이즈 업 */
const AvatarCircle = styled(motion.div)`
  width: 80px;
  height: 80px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: transparent;
  box-shadow: none;
  position: absolute;
  top: -80px;
  overflow: hidden;
`;

const Mascot = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.22);
  transform-origin: center;
`;

const Mascot1 = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(2);
  transform-origin: center;
`;

function TiltBar({
  h = 240,
  variant = "gold",
  tilt = 15,
  delay = 0,
  sidePct = 0.1,
  children,
}) {
  const prefs = useReducedMotion();
  const v = PALETTE[variant] || PALETTE.gold;
  const sideW = `${Math.round(sidePct * 1000) / 10}%`;

  return (
    <TiltWrap
      $h={h}
      $tilt={prefs ? 0 : tilt}
      initial={prefs ? false : { scaleY: 0, opacity: 0, filter: "blur(8px)" }}
      animate={{ scaleY: 1, opacity: 1, filter: "blur(0px)" }}
      transition={{
        type: "spring",
        stiffness: 110,
        damping: 18,
        duration: 1.15,
        delay,
      }}
      style={{ willChange: "transform" }}
    >
      <FrontFace $bg={v.front} />
      <RightFace $bg={v.side} $sideW={sideW} />
      <TopCap />
      {children}
    </TiltWrap>
  );
}

/* ================= Podium ================= */
const PodiumWrap = styled.div`
  position: absolute;
  inset: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
  row-gap: 8px;
  padding: 0 24px;
`;
const PodiumStage = styled(motion.div)`
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 10px;
  padding: 12px 0 0;
`;
const Col = styled(motion.div)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 96px;
  margin: 0 -3px;
`;

const NoticeText = styled.p`
  align-self: stretch;
  margin: 10px 2px 0px;   /* 위로 여유, 버튼과는 조금 간격 */
  font-size: 11px;
  line-height: 1.45;
  color: #6b7280;
  text-align: left;       /* 왼쪽부터 시작 */
  word-break: keep-all;
`;

const Crown = () => (
  <svg width="42" height="26" viewBox="0 0 64 38">
    <defs>
      <linearGradient id="gold" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#FFE677" />
        <stop offset="45%" stopColor="#FFD24D" />
        <stop offset="100%" stopColor="#E6A81E" />
      </linearGradient>
    </defs>
    <path
      d="M4 32L12 10l12 10 8-18 8 18 12-10 8 22H4Z"
      fill="url(#gold)"
      stroke="#B88900"
      strokeWidth="2"
    />
  </svg>
);

const CrownWrap = styled(motion.div)`
  position: absolute;
  top: -98px;
  transform: translateX(-50%);
  z-index: 3;
`;

const RankInBar = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 90%;
  text-align: center;
  letter-spacing: -0.4px;
  user-select: none;
  pointer-events: none;
  --rank: #222833;
  --score: rgba(0, 0, 0, 0.72);
  --name: #0f172a;
  --region: #0f172a;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
  .rank {
    color: var(--rank);
    font-weight: 900;
    font-size: ${(p) =>
    p.$size === "lg"
      ? "clamp(38px,6vw,40px)"
      : p.$size === "md"
        ? "clamp(28px,5vw,32px)"
        : "clamp(24px,4.6vw,28px)"};
    line-height: 1.02;
  }
  .score {
    color: var(--score);
    font-weight: 900;
    font-size: clamp(14px, 3vw, 18px);
    line-height: 1.02;
    white-space: nowrap;
    word-break: keep-all;
  }
  .name {
  
    color: var(--name);
    font-weight: 900;
    font-size: clamp(16px, 2.8vw, 17px);
    line-height: 1.02;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .region {
    margin-top: 30px;
    color: var(--region);
    font-weight: 900;
    font-size: clamp(16px, 2.8vw, 17px);
    line-height: 1.02;
  }
`;

const Name = styled.div`
  margin-top: 18px;
  color: #b0b4bc;
  font-weight: 800;
  font-size: 16px;
  text-align: center;
  white-space: nowrap;
  max-width: 96px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StageBase = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 28px;
  width: 92%;
  height: 18px;
  border-radius: 999px;
  background: radial-gradient(
    60% 100% at 50% 50%,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0) 70%
  );
`;

const glowPulse = keyframes`
  0%, 100% { box-shadow: 0 6px 14px rgba(0,0,0,.22), 0 0 0px rgba(255,217,90,0.0); }
  50%      { box-shadow: 0 6px 14px rgba(0,0,0,.22), 0 0 22px rgba(255,217,90,0.55); }
`;
const FirstGlow = styled.div`
  animation: ${glowPulse} 2.8s ease-in-out infinite;
`;

const ANIM = {
  stage: { delayChildren: 0.1, staggerChildren: 0.28 },
  col: {
    initial: { y: 20, opacity: 0, scale: 0.96, filter: "blur(6px)" },
    animate: { y: 0, opacity: 1, scale: 1, filter: "blur(0px)" },
    transition: { type: "spring", stiffness: 120, damping: 18, duration: 0.9 },
  },
  avatar: {
    initial: { y: -8, opacity: 0, scale: 0.9 },
    animate: { y: 0, opacity: 1, scale: 1 },
    transition: { type: "spring", stiffness: 180, damping: 18, duration: 0.9 },
  },
  crown: {
    initial: { scale: 0.5, opacity: 0, y: -8, rotate: -8 },
    animate: { scale: 1, opacity: 1, y: 0, rotate: 0 },
    transition: { type: "spring", stiffness: 240, damping: 16, duration: 0.9 },
  },
};

const formatKRW = (v) => {
  if (v == null || isNaN(v)) return "0원";
  return `${Number(v).toLocaleString("ko-KR")}원`;
};

function Top3Podium({ items }) {
  const prefs = useReducedMotion();
  const sorted = useMemo(
    () =>
      [...items].slice(0, 3).sort((a, b) => (b.sales || 0) - (a.sales || 0)),
    [items]
  );
  const first = sorted[0],
    second = sorted[1],
    third = sorted[2];
  const H1 = 256,
    H2 = 192,
    H3 = 160;
  
  console.log("data", first, second, third);

  return (
    <PodiumWrap>
      <div style={{ display: "grid", placeItems: "center" }}>
        <div style={{ color: "#fff", fontWeight: 900, opacity: 0.85 }}></div>
      </div>

      <PodiumStage
        variants={{}}
        initial="initial"
        animate="animate"
        transition={
          prefs
            ? undefined
            : {
              when: "beforeChildren",
              staggerChildren: ANIM.stage.staggerChildren,
              delayChildren: ANIM.stage.delayChildren,
            }
        }
      >
        {/* 2등 */}
        <Col variants={ANIM.col} transition={ANIM.col.transition}>
          <AvatarCircle
            variants={ANIM.avatar}
            transition={ANIM.avatar.transition}
          >
            <Mascot src={person2} alt="mascot" />
          </AvatarCircle>
          <TiltBar
            h={H2}
            variant="silver"
            tilt={-15}
            delay={prefs ? 0 : 0.25}
            sidePct={0.1}
          >
            <RankInBar $size="md">
              <div className="rank">2등</div>
              <div className="score">{formatKRW(second?.sales)}</div>
              <div className="region">{second?.region}</div>
              <div className="name">
                기사님
              </div>
          
            </RankInBar>
          </TiltBar>
        </Col>

        {/* 1등 */}
        <Col
          initial={ANIM.crown.initial}
          animate={ANIM.crown.animate}
          transition={{ ...ANIM.crown.transition, delay: prefs ? 0 : 0.15 }}
        >
          <SparkleWrap>
            <Sparkle
              style={{ left: 18, top: 10 }}
              $s={18}
              $dur={1.0}
              $delay={0.0}
              $theme="goldDeep"
            />
            <Sparkle
              style={{ left: 58, top: -12 }}
              $s={22}
              $dur={1.6}
              $delay={0.25}
              $theme="goldDeep"
            />
            <Sparkle
              style={{ left: 98, top: -26 }}
              $s={14}
              $dur={1.7}
              $delay={0.5}
              $theme="goldDeep"
            />
            <Sparkle
              style={{ left: 144, top: -6 }}
              $s={18}
              $dur={1.2}
              $delay={0.35}
              $theme="goldDeep"
            />
            <Sparkle
              style={{ left: 178, top: 22 }}
              $s={15}
              $dur={1.0}
              $delay={0.9}
              $theme="goldDeep"
            />
            <Sparkle
              style={{ left: 120, top: 40 }}
              $s={22}
              $dur={1.8}
              $delay={0.3}
              $theme="goldDeep"
            />
            <Sparkle
              style={{ left: 72, top: 34 }}
              $s={17}
              $dur={1.1}
              $delay={0.7}
              $theme="goldDeep"
            />
            <Sparkle
              style={{ left: 36, top: 28 }}
              $s={12}
              $dur={1.9}
              $delay={0.4}
              $theme="goldDeep"
            />
            <Sparkle
              style={{ left: 156, top: 32 }}
              $s={12}
              $dur={2.3}
              $delay={0.6}
              $theme="goldDeep"
            />
          </SparkleWrap>

          <FirstGlow>
            <AvatarCircle
              initial={ANIM.avatar.initial}
              animate={ANIM.avatar.animate}
              transition={{
                ...ANIM.avatar.transition,
                delay: prefs ? 0 : 0.1,
              }}
              style={{ left: "20px", transform: "translateX(-50%)", top: -80 }}
            >
              <Mascot1 src={corp1} alt="mascot" />
            </AvatarCircle>
          </FirstGlow>

          <TiltBar
            h={H1}
            variant="gold"
            tilt={0}
            delay={prefs ? 0 : 0.1}
            sidePct={0.1}
          >
            <RankInBar $size="lg" $color="#C78218">
              <div className="rank">1등</div>
              <div className="score">{formatKRW(first?.sales)}</div>
              <div className="region">{first?.region}</div>
              <div className="name">
                기사님
              </div>

            </RankInBar>
          </TiltBar>
        </Col>

        {/* 3등 */}
        <Col variants={ANIM.col} transition={ANIM.col.transition}>
          <AvatarCircle
            variants={ANIM.avatar}
            transition={ANIM.avatar.transition}
          >
            <Mascot src={person3} alt="mascot" />
          </AvatarCircle>
          <TiltBar
            h={H3}
            variant="bronze"
            tilt={15}
            delay={prefs ? 0 : 0.4}
            sidePct={0.1}
          >
            <RankInBar $size="sm" $color="#C06A54">
              <div className="rank">3등</div>
              <div className="score">{formatKRW(third?.sales)}</div>
              <div className="region">{third?.region}</div>
              <div className="name">
                기사님
              </div>

            </RankInBar>
          </TiltBar>
        </Col>
      </PodiumStage>

      <StageBase />
    </PodiumWrap>
  );
}

/* ================= 4~10등 리스트 ================= */
const ListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

/* 이미지 폭 조금 줄이고, 이름/지역에 더 많은 공간 할당 */
const Row = styled.div`
  display: grid;
  grid-template-columns: 48px 48px 1fr auto;
  align-items: center;
  gap: 10px 10px;
  padding: 12px 14px;
  border-radius: 14px;
  background: ${(p) =>
    p.$late
      ? "linear-gradient(180deg,#FFD9C8 0%, #FFB89F 100%)"
      : "linear-gradient(180deg,#FFC3CF 0%, #FFA7B7 100%)"};
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.06);
  color: #111;
`;

const AvatarSm = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 999px;
  object-fit: cover;
  background: transparent;
  box-shadow: none;
`;

const NameArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  .name {
    font-weight: 900;
    color: #111;
    font-size: 16px;
    line-height: 1.2;
    word-break: keep-all;
  }
  .region {
    margin-top: 4px;
    font-weight: 900;
    color: #111;
    font-size: 16px;
    line-height: 1.2;
    word-break: keep-all;
  }
`;

const RankBadgeSm = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: #fff;
  display: grid;
  place-items: center;
  font-weight: 900;
  color: #ff3b6b;
  border: 2px solid rgba(255, 59, 107, 0.3);
`;

const Score = styled.div`
  font-weight: 900;
  color: #111;
  white-space: nowrap;
`;

/* ================= Page ================= */
export default function SalesRankingPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const period = params.get("period") || "30일";

  const { status, memberType } = useDriverStatusContext();
  const { config } = useAppConfig();
  const accessCfg = config.access || {};
  const mySalesAccess = accessCfg.mySales || {};
  const corporateViewAccess = accessCfg.corporateView || {};  // 🔹 여기

  console.log("corporateViewAccess", corporateViewAccess);


  const corpLock = config.detailScreens.corporateScreenLock || {};
  const corpLockEnabled = !!corpLock.enabled;
  const corpLockMessage = corpLock.message || "오픈 예정입니다.";
  const corpLockIcon = corpLock.iconImg || ""

  console.log("corpLock", corpLock);


  const [data, setData] = useState([]);
  const [latestMonthLabel, setLatestMonthLabel] = useState("");
  const [loading, setLoading] = useState(true);

  const goMine = () => {
    // 0차: 법인 회원은 내정보 매출 진입 자체를 막기
    if (status === "member" && memberType === "corporate") {
      const msg = "법인 회원은 금액을 확인할 수 없습니다.";
      window.alert(msg);
      return;
    }

    // 1차: 게스트 가드
    if (status === "guest") {
      const msg =
        mySalesAccess.message ||
        "매출 내역은 로그인 및 가맹 승인 후 이용 가능합니다.\n관리자에게 문의해 주세요.";
      window.alert(msg);
      return;
    }

    // 통과 시에만 이동
    navigate("/sales/mine");
  };
  const goCorp = () => {
    // 1차: 메뉴 잠금(전체 잠금) — 켜져 있으면 누구든 안내만 보여주고 끝
    if (corpLockEnabled) {
      window.alert(corpLockMessage);
      return;
    }

    // 2차: 접근 제어 — enabled일 때만 게스트/조건 체크
    if (corporateViewAccess.enabled) {
      if (status === "guest") {
        const msg =
          corporateViewAccess.message ||
          "법인 매출/랭킹 화면은 로그인 후 이용 가능합니다.\n자세한 내용은 본사로 문의해 주세요.";
        window.alert(msg);
        return;
      }
      // 여기서 추가 조건(예: memberType === 'corporate') 넣고 싶으면 여기에
    }

    // 1차 잠금도 없고, 2차 가드에서도 통과했으면 이동
    navigate("/sales/ranking/corp");
  };




  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        const top = await fetchTopSettlementsByFare(10, {
          onlyWithFourDigits: true,
          kind: "personal",
        });
        console.log("ranking top", top);

        if (!alive) return;

        // ✅ 서비스에서 달고 온 latestMonthKey → "10월"로 변환
        if (top && top.latestMonthKey) {
          setLatestMonthLabel(formatSettlementMonthLabel(top.latestMonthKey));
        } else {
          setLatestMonthLabel("");
        }

        setData(
          (top || []).map((r, i) => ({
            rank: i + 1,
            user: r.user,
            sales: Number(r.sales),
            region: r.region || 0,
          }))
        );
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const top3 = useMemo(() => (data || []).slice(0, 3), [data]);
  const rest = useMemo(() => (data || []).slice(3, 10), [data]);

  const subtitle = latestMonthLabel
    ? ` 개인 가맹기사 ${latestMonthLabel} 매출내역 / 랭킹`
    : ` 개인 가맹기사 매출내역 / 랭킹`;

  return (
    <Wrap>
      <Sheet>
        <PageTopBar borderColor="#dde7fb" />

        <Hero>
    
            <HeroText>
              <h1></h1>
              <LinkBtn onClick={goCorp} $locked={corpLockEnabled}>
                {corpLockEnabled && (
                  corpLockIcon ? (
                    <img
                      src={corpLockIcon}
                      alt="locked"
                      style={{
                        width: 18,
                        height: 18,
                        borderRadius: 4,
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <span style={{ fontSize: 13 }}>🔒</span>
                  )
                )}
          
                법인 보러가기
              </LinkBtn>
            </HeroText>

   
        </Hero>

        <Body>
          <BrandHeader subtitle={subtitle} />

          <Card>
            {loading ? (
              <div style={{ color: "#fff", padding: 16 }}>
                랭킹을 불러오는 중…
              </div>
            ) : top3.length < 3 ? (
              <div style={{ color: "#fff", padding: 16 }}>
                데이터가 부족합니다.
              </div>
            ) : (
              <MotionConfig reducedMotion="user">
                <Top3Podium items={top3} />
              </MotionConfig>
            )}
          </Card>

          {!loading && rest?.length > 0 && (
            <ListWrap>
              {rest.map((item) => {
                const isLate = item.rank >= 6;
                return (
                  <Row key={item.rank} $late={isLate}>
                    <RankBadgeSm>{item.rank}등</RankBadgeSm>
                    <AvatarSm src={person4} alt="avatar" />
                    <NameArea>
                      <div className="region">{item.region}</div>
                      <div className="name">기사님</div>
        
                    </NameArea>
                    <Score>{formatKRW(item.sales)}</Score>
                  </Row>
                );
              })}
            </ListWrap>
          )}

          <NoticeText>
            매출 랭킹은 매월 익월 10일 전후로 최신화되며,
            1~10위만 공개되고 성함은 노출되지 않습니다.
          </NoticeText>

          <CTA onClick={goMine}>
            내 정보 매출 보러가기 <Arrow />
          </CTA>
          <BottomPad />
        </Body>
      </Sheet>
    </Wrap>
  );
}
